import React, { useEffect } from 'react';
import ReactPopup from 'reactjs-popup';
import styles from './style.css';

const Popup = ({ children, ...props }) => {
    useEffect(() => {
        document.body.classList.add('popup-open');
        return () => document.body.classList.remove('popup-open');
    });

    const overlayStyle = props.overlayStyle || {};

    if (!overlayStyle.zIndex) {
        overlayStyle.zIndex = '2201';
    }

    return (
        <ReactPopup {...props} overlayStyle={overlayStyle}>
            <div id={props.popupID} data-metrics-location="PU">
                {children}
            </div>
            <style jsx>{styles}</style>
        </ReactPopup>
    );
};

export default Popup;
